import { render, staticRenderFns } from "./OperaDeclareServiceWindow.vue?vue&type=template&id=0246b3fc&"
import script from "./OperaDeclareServiceWindow.vue?vue&type=script&lang=js&"
export * from "./OperaDeclareServiceWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports